// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_fM","advertDetailService__price":"c-p_fN"};